/* ==========================
Loading Screen
========================== */
function initLoadingScreen() {
  const loadingScreen = document.querySelector(".js-loading-screen");
  const storageKey = "volixLoadingScreenViewed";
  const isThemeEditor =
    window.Shopify && window.Shopify.designMode;

  let hasViewed = false;

  if (!isThemeEditor) {
    try {
      hasViewed =
        sessionStorage.getItem(storageKey) === "true";
    } catch (error) {
      console.warn(
        "sessionStorageを利用できませんでした。",
        error
      );
    }
  }

  let hasStartedMainVisual = false;

  function startMainVisual() {
    if (hasStartedMainVisual) return;

    hasStartedMainVisual = true;

    requestAnimationFrame(() => {
      initMainVisual();
    });
  }

  /*
   * ローディング画面が存在しない場合
   */
  if (!loadingScreen) {
    document.documentElement.classList.remove(
      "volix-loading-before-ready",
      "is-loading-screen"
    );

    startMainVisual();
    return;
  }

  /*
   * セッション内ですでに表示済みの場合
   */
  if (hasViewed) {
    loadingScreen.remove();

    document.documentElement.classList.remove(
      "volix-loading-before-ready",
      "is-loading-screen"
    );

    startMainVisual();
    return;
  }

  const skipButton = loadingScreen.querySelector(
    ".js-loading-skip"
  );
  const videoPc = loadingScreen.querySelector(
    ".js-loading-video-pc"
  );
  const videoSp = loadingScreen.querySelector(
    ".js-loading-video-sp"
  );
  const loadingLogo = loadingScreen.querySelector(
    ".js-loading-logo"
  );

  const isSp = window.matchMedia(
    "(max-width: 767px)"
  ).matches;

  const activeVideo = isSp ? videoSp : videoPc;

  const duration =
    Number(loadingScreen.dataset.loadingDuration) || 5000;

  let finishTimer = null;
  let loadTimer = null;
  let removeTimer = null;
  let isFinished = false;
  let hasStartedTimer = false;

  function saveViewedState() {
    if (isThemeEditor) return;

    try {
      sessionStorage.setItem(storageKey, "true");
    } catch (error) {
      console.warn(
        "sessionStorageを利用できませんでした。",
        error
      );
    }
  }

  function clearTimers() {
    if (finishTimer) {
      clearTimeout(finishTimer);
      finishTimer = null;
    }

    if (loadTimer) {
      clearTimeout(loadTimer);
      loadTimer = null;
    }

    if (removeTimer) {
      clearTimeout(removeTimer);
      removeTimer = null;
    }
  }

  function removeLoadingScreen() {
    if (loadingScreen.isConnected) {
      loadingScreen.remove();
    }

    document.documentElement.classList.remove(
      "volix-loading-before-ready",
      "is-loading-screen"
    );

    startMainVisual();
  }

  function hideLoadingScreen() {
    if (isFinished) return;

    isFinished = true;
    clearTimers();
    saveViewedState();

    if (activeVideo) {
      activeVideo.pause();
    }

    loadingScreen.classList.add("is-hidden");

    document.documentElement.classList.remove(
      "volix-loading-before-ready",
      "is-loading-screen"
    );

    const onTransitionEnd = event => {
      if (
        event.target !== loadingScreen ||
        event.propertyName !== "opacity"
      ) {
        return;
      }

      loadingScreen.removeEventListener(
        "transitionend",
        onTransitionEnd
      );

      removeLoadingScreen();
    };

    loadingScreen.addEventListener(
      "transitionend",
      onTransitionEnd
    );

    /*
     * transitionendが発火しない場合の保険
     */
    removeTimer = setTimeout(() => {
      removeLoadingScreen();
    }, 1000);
  }

  function startFinishTimer() {
    if (hasStartedTimer || isFinished) return;

    hasStartedTimer = true;

    if (loadTimer) {
      clearTimeout(loadTimer);
      loadTimer = null;
    }

    finishTimer = setTimeout(() => {
      hideLoadingScreen();
    }, duration);
  }

  function showLogoMode() {
    if (isFinished) return;

    if (activeVideo) {
      activeVideo.pause();
    }

    loadingScreen.classList.add("is-logo-mode");

    if (loadingLogo) {
      loadingLogo.setAttribute(
        "aria-hidden",
        "false"
      );
    }

    startFinishTimer();
  }

  document.documentElement.classList.add(
    "is-loading-screen"
  );

  /*
   * 本物のローディング画面が描画されたら
   * theme.liquid側の事前カバーを外す
   */
  requestAnimationFrame(() => {
    document.documentElement.classList.remove(
      "volix-loading-before-ready"
    );
  });

  /*
   * スキップ
   */
  if (skipButton) {
    skipButton.addEventListener(
      "click",
      event => {
        event.preventDefault();
        hideLoadingScreen();
      },
      { once: true }
    );
  }

  /*
   * 閲覧端末用の動画が設定されていない場合
   */
  if (!activeVideo) {
    showLogoMode();
    return;
  }

  activeVideo.addEventListener(
    "playing",
    startFinishTimer,
    { once: true }
  );

  activeVideo.addEventListener(
    "ended",
    hideLoadingScreen,
    { once: true }
  );

  activeVideo.addEventListener(
    "error",
    showLogoMode,
    { once: true }
  );

  /*
   * 使用する動画だけ読み込む
   */
  const sources = activeVideo.querySelectorAll(
    "source[data-src]"
  );

  if (!sources.length) {
    showLogoMode();
    return;
  }

  sources.forEach(source => {
    source.src = source.dataset.src;
    source.removeAttribute("data-src");
  });

  /*
   * 動画読み込みが長時間進まない場合
   */
  loadTimer = setTimeout(() => {
    console.warn(
      "ローディング動画の読み込みに時間がかかったため、ロゴ表示へ切り替えました。"
    );

    showLogoMode();
  }, 10000);

  activeVideo.load();

  try {
    activeVideo.currentTime = 0;
  } catch (error) {
    console.warn(
      "ローディング動画の再生位置を初期化できませんでした。",
      error
    );
  }

  const playPromise = activeVideo.play();

  if (
    playPromise &&
    typeof playPromise.catch === "function"
  ) {
    playPromise.catch(error => {
      console.warn(
        "ローディング動画を自動再生できなかったため、ロゴ表示へ切り替えました。",
        error
      );

      showLogoMode();
    });
  }
}

/* ==========================
Initialize Loading Screen
========================== */
function initVolixTopPage() {
  initLoadingScreen();
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    initVolixTopPage,
    { once: true }
  );
} else {
  initVolixTopPage();
}


/* ==========================
Main Visual
========================== */
function initMainVisual() {
  const mvSections = document.querySelectorAll(".mv");

  if (!mvSections.length || typeof Swiper === "undefined") return;

  mvSections.forEach((section) => {
    const slider = section.querySelector(".js-mv-slider");
    const contents = Array.from(
      section.querySelectorAll(".js-mv-content")
    );

    if (!slider || slider.dataset.initialized === "true") return;

    slider.dataset.initialized = "true";

    const slideCount =
      slider.querySelectorAll(".swiper-slide").length;

    const autoplaySpeed =
      Number(section.dataset.autoplaySpeed) || 7000;

    function switchContent(index) {
      contents.forEach((content, contentIndex) => {
        content.classList.toggle(
          "is-active",
          contentIndex === index
        );
      });
    }

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      speed: 900,
      loop: slideCount > 1,
      autoplay:
        slideCount > 1
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
            }
          : false,

      on: {
        init(swiperInstance) {
          switchContent(swiperInstance.realIndex);
        },

        slideChangeTransitionStart(swiperInstance) {
          switchContent(swiperInstance.realIndex);
        },
      },
    });
    section.mvSwiper = swiper;
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initMainVisual();
});
document.addEventListener("shopify:section:load", () => {
  initMainVisual();
});


/* ==========================
fade anime
========================== */
// function initProductFade() {
//   const sections = document.querySelectorAll(".featured-products, .pickup-products");
//   if (!sections.length) return;
//   sections.forEach((section) => {
//     if (section.dataset.fadeInit) return;
//     section.dataset.fadeInit = "true";
//     const items = section.querySelectorAll(".grid__item");
//     if (!items.length) return;
//     const observer = new IntersectionObserver(
//       (entries, obs) => {
//         entries.forEach((entry) => {
//           if (!entry.isIntersecting) return;

//           items.forEach((item, index) => {
//             setTimeout(() => {
//               item.classList.add("is-show");
//             }, index * 300);
//           });
//           obs.unobserve(section);
//         });
//       },
//       {
//         threshold: 0.15,
//         rootMargin: "0px 0px -10% 0px"
//       }
//     );
//     observer.observe(section);
//   });
// }
// document.addEventListener("DOMContentLoaded", initProductFade);
// document.addEventListener("shopify:section:load", initProductFade);


/* ==========================
header hight 
========================== */
const header = document.querySelector(".site-header");
function setHeaderHeight() {
  document.documentElement.style.setProperty(
    "--header-height",
    `${header.offsetHeight}px`
  );
}
window.addEventListener("load", setHeaderHeight);
window.addEventListener("resize", setHeaderHeight);


/* ==========================
pick up products swiper
========================== */
function initProductSliders() {
  const sliders = document.querySelectorAll(".js-product-slider");
  if (!sliders.length || typeof Swiper === "undefined") return;
  sliders.forEach(slider => {
    if (slider.dataset.swiperInit === "true") return;
    slider.dataset.swiperInit = "true";
    new Swiper(slider, {
      slidesPerView: 1.5,
      spaceBetween: 12,
      speed: 600,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      breakpoints: {
        897: {
          slidesPerView: 4,
          spaceBetween: 24,
          allowTouchMove: false
        }
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", initProductSliders);



/* ==========================
collection-sort-sidebar
========================== */
function initCollectionSortSidebar() {
  const sortButtons = document.querySelectorAll(".collection-sort-sidebar__button");
  const sortSelect = document.querySelector("#SortBy");
  if (!sortButtons.length || !sortSelect) return;

  sortButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const value = button.dataset.sortValue;
      if (!value) return;

      sortButtons.forEach((btn) => btn.classList.remove("is-active"));
      button.classList.add("is-active");

      sortSelect.value = value;
      sortSelect.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
}

document.addEventListener("DOMContentLoaded", initCollectionSortSidebar);
document.addEventListener("shopify:section:load", initCollectionSortSidebar);


/* ==========================
collection-custom-filter
========================== */
function initCollectionCustomFilters() {
  const buttons = document.querySelectorAll(
    ".collection-custom-filter button[data-filter-name], .collection-product-list__category button[data-filter-name]"
  );
  if (!buttons.length) return;

  const currentUrl = new URL(window.location.href);

  buttons.forEach((button) => {
    const name = button.dataset.filterName;
    const value = button.dataset.filterValue;
    if (!name || !value) return;

    const currentValues = currentUrl.searchParams.getAll(name);
    const isActive = currentValues.includes(value);

    button.classList.toggle("is-active", isActive);

    button.addEventListener("click", () => {
      const nextUrl = new URL(window.location.href);
      const isCategoryButton = button.closest(
        ".collection-product-list__category"
      );

      if (isCategoryButton) {
        const isSelected = nextUrl.searchParams.getAll(name).includes(value);

        nextUrl.searchParams.delete(name);

        if (!isSelected) {
          nextUrl.searchParams.append(name, value);
        }
      } else {
        const values = nextUrl.searchParams.getAll(name);
        const isSelected = values.includes(value);

        const nextValues = isSelected
          ? values.filter((item) => item !== value)
          : [...values, value];

        nextUrl.searchParams.delete(name);

        nextValues.forEach((item) => {
          nextUrl.searchParams.append(name, item);
        });
      }

      nextUrl.searchParams.delete("page");
      window.location.href = nextUrl.toString();
    });
  });
}
document.addEventListener("DOMContentLoaded", initCollectionCustomFilters);
document.addEventListener("shopify:section:load", initCollectionCustomFilters);


/* ==========================
collection-filter-drawer
========================== */
function initCollectionFilterDrawer() {
  const openButtons = document.querySelectorAll(
    ".js-drawer-open-collection-filters"
  );
  const drawer = document.querySelector("#FilterDrawer");
  const closeButtons = document.querySelectorAll(
    "#FilterDrawer .js-drawer-close"
  );
  if (!openButtons.length || !drawer) return;

  openButtons.forEach((button) => {
    button.addEventListener("click", () => {
      drawer.classList.add("is-open");
      document.body.classList.add("collection-filter-drawer-open");
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      drawer.classList.remove("is-open");
      document.body.classList.remove("collection-filter-drawer-open");
    });
  });
}

document.addEventListener("DOMContentLoaded", initCollectionFilterDrawer);
document.addEventListener("shopify:section:load", initCollectionFilterDrawer);





/* ==========================
Collection load more
========================== */
function initCollectionLoadMore() {
  const productGrid = document.querySelector(".collection-product-list__content");
  const loadMoreButton = document.querySelector(".js-load-more-button");

  if (!productGrid || !loadMoreButton) return;

  const products = Array.from(
    productGrid.querySelectorAll(".grid__item.grid-product")
  );

  const initialCount = 24;
  const addCount = 8;
  let visibleCount = initialCount;

  function updateProducts() {
    products.forEach((product, index) => {
      product.classList.toggle("is-hidden", index >= visibleCount);
    });

    loadMoreButton.classList.toggle(
      "is-hidden",
      visibleCount >= products.length
    );

    if (window.AOS) {
      setTimeout(() => {
        AOS.refreshHard();
      }, 100);
    }
  }

  loadMoreButton.onclick = () => {
    visibleCount += addCount;
    updateProducts();
  };

  updateProducts();
}

function watchCollectionAjaxContent() {
  const ajaxContent = document.querySelector("#CollectionAjaxContent");
  if (!ajaxContent) return;

  const observer = new MutationObserver(() => {
    initCollectionLoadMore();
  });

  observer.observe(ajaxContent, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initCollectionLoadMore();
  watchCollectionAjaxContent();
});


/* ==========================
custom cursor
========================== */
function initProductZoomCursor() {
  if (window.innerWidth < 1025) return;
  const area = document.querySelector(".template-product .product__main-photos");
  if (!area) return;
  const iconUrl = area.dataset.cursorIcon;
  const slideshow = area.querySelector(".product-slideshow");
  if (!slideshow || !iconUrl) return;
  if (document.querySelector(".product-zoom-cursor")) return;
  const cursor = document.createElement("div");
  cursor.className = "product-zoom-cursor";
  cursor.innerHTML = `<img src="${iconUrl}" alt="">`;
  document.body.appendChild(cursor);
  let mouseX = 0;
  let mouseY = 0;
  let cursorX = 0;
  let cursorY = 0;
  let isActive = false;
  area.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    const target = e.target.closest(".product-main-slide.is-selected .product-image-main");
    if (target) {
      isActive = true;
      cursor.classList.add("is-show");
      slideshow.classList.add("is-custom-cursor-active");
    } else {
      isActive = false;
      cursor.classList.remove("is-show");
      slideshow.classList.remove("is-custom-cursor-active");
    }
  });
  area.addEventListener("mouseleave", () => {
    isActive = false;
    cursor.classList.remove("is-show");
    slideshow.classList.remove("is-custom-cursor-active");
  });
  function animate() {
    cursorX += (mouseX - cursorX) * 0.18;
    cursorY += (mouseY - cursorY) * 0.18;
    if (isActive) {
      cursor.style.left = `${cursorX}px`;
      cursor.style.top = `${cursorY}px`;
    }
    requestAnimationFrame(animate);
  }
  animate();
}
document.addEventListener("page:loaded", initProductZoomCursor);
document.addEventListener("DOMContentLoaded", initProductZoomCursor);


/* ==========================
Judge.me review
========================== */
function initJudgeMe() {
  document.querySelectorAll(".jdgm-title").forEach((title) => {
    title.classList.add("en");
  });
  document.querySelectorAll(".jdgm-card.jdgm-media-card").forEach((card) => {
    card.classList.add("--neo", "-bk");
  });
  document.querySelectorAll(".jdgm-prev-badge").forEach((badge) => {
    const count = Number(badge.dataset.numberOfReviews || 0);
    const rating = Number(badge.dataset.averageRating || 0);
    const roundedRating = Math.round(rating * 2) / 2;
    if (count === 0) {
      badge.closest(".product-block--app")?.remove();
      return;
    }
    const text = badge.querySelector(".jdgm-prev-badge__text");
    if (text) {
      text.textContent = `${count}件のレビュー`;
    }
    const stars = badge.querySelectorAll(".jdgm-star");
    stars.forEach((star, index) => {
      const starNumber = index + 1;
      star.classList.remove("jdgm--on", "jdgm--half", "jdgm--off");
      if (roundedRating >= starNumber) {
        star.classList.add("jdgm--on");
      } else if (roundedRating === starNumber - 0.5) {
        star.classList.add("jdgm--half");
      } else {
        star.classList.add("jdgm--off");
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", initJudgeMe);
setTimeout(initJudgeMe, 500);
setTimeout(initJudgeMe, 1500);


/* ==========================
smooth scroll
========================== */
function smoothScroll(target) {
  if (!target) return;

  const headerHeight =
    parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("--header-height")
    ) || 0;

  const targetPosition =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    headerHeight;

  window.scrollTo({
    top: targetPosition,
    behavior: "smooth"
  });
}
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener("click", function(e) {
    const href = this.getAttribute("href");
    if (href === "#") return;

    const target = document.querySelector(href);
    if (!target) return;

    e.preventDefault();
    smoothScroll(target);
  });
});

/* ==========================
Judge.me
========================== */
document.addEventListener("click", (e) => {
  const badge = e.target.closest(".jdgm-prev-badge");
  if (!badge) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const reviews = document.querySelector("#Reviews");
  if (!reviews) return;

  setTimeout(() => {
    smoothScroll(reviews);
  }, 50);
}, true);


/*============================================================================
  Product description read more
==============================================================================*/
function initProductDescriptionReadMore() {
  const rte = document.querySelector(".js-product-description");
  if (!rte) return;
  if (rte.dataset.readmoreInitialized === "true") return;
  rte.dataset.readmoreInitialized = "true";
  rte.classList.add("product-description-rte");
  rte.style.maxHeight = "155px";
  const button = document.createElement("button");
  button.type = "button";
  button.className = "product-description-readmore";
  button.textContent = "Read more +";
  rte.parentNode.insertBefore(button, rte.nextSibling);
  button.addEventListener("click", () => {
    const isOpen = rte.classList.contains("is-open");
    if (isOpen) {
      rte.style.maxHeight = `${rte.scrollHeight}px`;
      requestAnimationFrame(() => {
        rte.style.maxHeight = "155px";
      });
      rte.classList.remove("is-open");
      button.textContent = "Read more +";
    } else {
      rte.style.maxHeight = `${rte.scrollHeight}px`;
      rte.classList.add("is-open");
      button.textContent = "Close ー";
    }
  });
}
document.addEventListener("DOMContentLoaded", initProductDescriptionReadMore);
document.addEventListener("shopify:section:load", initProductDescriptionReadMore);


/*============================================================================
  Variant selected label
==============================================================================*/
function initVariantSelectedLabel() {
  const wrappers = document.querySelectorAll(".template-product .variant-wrapper");
  if (!wrappers.length) return;
  wrappers.forEach((wrapper) => {
    const label = wrapper.querySelector(".js-variant-selected-value");
    const inputs = wrapper.querySelectorAll("input[data-variant-input]");
    if (!label || !inputs.length) return;
    inputs.forEach((input) => {
      input.addEventListener("change", () => {
        if (!input.checked) return;
        label.textContent = input.value;
      });
    });
  });
}
document.addEventListener("DOMContentLoaded", initVariantSelectedLabel);
document.addEventListener("shopify:section:load", initVariantSelectedLabel);


/*============================================================================
  guide accordion
==============================================================================*/
function initGuideAccordion() {
  const sections = document.querySelectorAll(".guide-section");
  if (!sections.length) return;
  sections.forEach((section) => {
    if (section.dataset.accordionInitialized === "true") return;
    section.dataset.accordionInitialized = "true";
    const item = section.querySelector(".guide-section__item");
    const button = section.querySelector(".guide-section__head");
    const body = section.querySelector(".guide-section__body");
    if (!item || !button || !body) return;
    function adjustScrollPosition() {
      const header = document.querySelector(".site-header");
      const headerHeight = header ? header.offsetHeight : 0;
      const topMargin = 16;
      const buttonTop = button.getBoundingClientRect().top;
      const visibleTop = headerHeight + topMargin;
      if (buttonTop >= visibleTop) return;
      window.scrollBy({
        top: buttonTop - visibleTop,
        behavior: "smooth",
      });
    }
    function openItem(animate = true) {
      item.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");
      body.style.visibility = "visible";
      if (!animate) {
        body.style.height = "auto";
        return;
      }
      body.style.height = "0px";
      requestAnimationFrame(() => {
        body.style.height = `${body.scrollHeight}px`;
      });
    }
    function closeItem(animate = true) {
      item.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");
      if (!animate) {
        body.style.height = "0px";
        body.style.visibility = "hidden";
        return;
      }
      if (body.style.height === "auto") {
        body.style.height = `${body.scrollHeight}px`;
        body.offsetHeight;
      }
      requestAnimationFrame(() => {
        body.style.height = "0px";
      });
    }
    if (item.classList.contains("is-open")) {
      openItem(false);
    } else {
      closeItem(false);
    }
    button.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");
      document
        .querySelectorAll(".guide-section__item.is-open")
        .forEach((otherItem) => {
          if (otherItem === item) return;
          const otherButton = otherItem.querySelector(
            ".guide-section__head"
          );
          const otherBody = otherItem.querySelector(
            ".guide-section__body"
          );
          if (!otherButton || !otherBody) return;
          otherItem.classList.remove("is-open");
          otherButton.setAttribute("aria-expanded", "false");
          if (otherBody.style.height === "auto") {
            otherBody.style.height = `${otherBody.scrollHeight}px`;
            otherBody.offsetHeight;
          }
          requestAnimationFrame(() => {
            otherBody.style.height = "0px";
          });
        });

      if (isOpen) {
        closeItem();
      } else {
        openItem();
      }
    });
    body.addEventListener("transitionend", (event) => {
      if (event.propertyName !== "height") return;

      if (item.classList.contains("is-open")) {
        body.style.height = "auto";
        adjustScrollPosition();
      } else {
        body.style.visibility = "hidden";
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", initGuideAccordion);
document.addEventListener("shopify:section:load", initGuideAccordion);



/*============================================================================
  submit btn
==============================================================================*/
document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector(".contact-form-section form");
  if (!form) return;

  form.addEventListener("submit", () => {
    const button = form.querySelector(".contact-form-section__button");
    if (!button) return;

    button.classList.add("is-loading");
    button.disabled = true;
  });
});


/*============================================================================
  policy
==============================================================================*/
function initPolicy() {
  const body = document.querySelector(".shopify-policy__body");
  if (!body || body.dataset.initialized === "true") return;

  const content = body.querySelector(".rte") || body;
  const paragraphs = Array.from(content.querySelectorAll(":scope > p"));

  if (!paragraphs.length) return;

  body.dataset.initialized = "true";

  document.body.classList.add(
    `policy-${window.location.pathname.split("/").pop()}`
  );

  const path = window.location.pathname;
  const isRefundPolicy = path.includes("/policies/refund-policy");
  const isLegalNotice = path.includes("/policies/legal-notice");

  let currentBlock = null;

  paragraphs.forEach((paragraph) => {
    const text = paragraph.textContent.trim();

    paragraph.classList.remove(
      "policy-heading",
      "policy-subheading",
      "policy-list",
      "policy-empty",
      "policy-intro"
    );

    if (!text || text === "\u00A0") {
      paragraph.classList.add("policy-empty");

      if (currentBlock) {
        currentBlock.appendChild(paragraph);
      }

      return;
    }

    const isArticleHeading = /^第[0-9０-９]+条/.test(text);
    const isMarkedHeading =
      (isRefundPolicy || isLegalNotice) && /^■/.test(text);

    if (isArticleHeading || isMarkedHeading) {
      paragraph.classList.add("policy-heading");

      if (isMarkedHeading) {
        removePolicyHeadingMark(paragraph);
      }

      currentBlock = document.createElement("div");
      currentBlock.classList.add("policy-block");

      paragraph.before(currentBlock);
      currentBlock.appendChild(paragraph);

      return;
    }

    if (/^＜.*＞$/.test(text)) {
      paragraph.classList.add("policy-subheading");
    }

    if (/^[a-z]\)/i.test(text) || /^\([0-9０-９]+\)/.test(text)) {
      paragraph.classList.add("policy-list");
    }

    if (currentBlock) {
      currentBlock.appendChild(paragraph);
    }
  });

  const blocks = content.querySelectorAll(":scope > .policy-block");

  blocks.forEach((block, index) => {
    block.classList.toggle("is-first", index === 0);
    block.classList.toggle("is-last", index === blocks.length - 1);
  });

  const introParagraphs = [];
  let node = content.firstElementChild;

  while (node && !node.classList.contains("policy-block")) {
    const nextNode = node.nextElementSibling;

    if (
      node.tagName === "P" &&
      !node.classList.contains("policy-empty") &&
      !node.classList.contains("policy-heading") &&
      !node.classList.contains("policy-subheading") &&
      !node.classList.contains("policy-list")
    ) {
      introParagraphs.push(node);
    }

    node = nextNode;
  }

  if (introParagraphs.length) {
    const intro = document.createElement("p");
    intro.className = "policy-intro";

    intro.innerHTML = introParagraphs
      .map((paragraph) => paragraph.innerHTML)
      .join("<br>");

    introParagraphs[0].before(intro);

    introParagraphs.forEach((paragraph) => {
      paragraph.remove();
    });
  }
}

function removePolicyHeadingMark(paragraph) {
  const walker = document.createTreeWalker(
    paragraph,
    NodeFilter.SHOW_TEXT
  );

  while (walker.nextNode()) {
    const textNode = walker.currentNode;

    if (/^\s*■/.test(textNode.nodeValue)) {
      textNode.nodeValue = textNode.nodeValue.replace(/^(\s*)■\s*/, "$1");
      break;
    }
  }
}

document.addEventListener("DOMContentLoaded", initPolicy);
document.addEventListener("shopify:section:load", initPolicy);


/*============================================================================
  Blog / News View more
==============================================================================*/
function initBlogListViewMore() {
  const blogLists = document.querySelectorAll("[data-blog-list]");
  if (!blogLists.length) return;
  blogLists.forEach((blogList) => {
    if (blogList.dataset.blogViewMoreInitialized === "true") return;
    const items = Array.from(blogList.querySelectorAll("[data-blog-item]"));
    const button = blogList.querySelector("[data-blog-more]");
    const perPage = Number(blogList.dataset.blogPerPage) || 12;
    if (!items.length) return;
    blogList.dataset.blogViewMoreInitialized = "true";
    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => {
            const aTop = a.target.getBoundingClientRect().top;
            const bTop = b.target.getBoundingClientRect().top;
            return aTop - bTop;
          });
        visibleEntries.forEach((entry, index) => {
          const item = entry.target;
          window.setTimeout(() => {
            item.classList.add("is-show");
          }, index * 100);
          observer.unobserve(item);
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -10% 0px",
        threshold: 0.15,
      }
    );
    function observeVisibleItems() {
      items.forEach((item) => {
        if (!item.hidden && !item.classList.contains("is-show")) {
          observer.observe(item);
        }
      });
    }
    if (!button) {
      observeVisibleItems();
      return;
    }
    let visibleCount = items.filter((item) => !item.hidden).length;
    function updateButton() {
      if (visibleCount >= items.length) {
        button.hidden = true;
      }
    }
    button.addEventListener("click", () => {
      const nextItems = items.slice(visibleCount, visibleCount + perPage);
      nextItems.forEach((item) => {
        item.hidden = false;
      });
      visibleCount += nextItems.length;
      observeVisibleItems();
      updateButton();
    });
    observeVisibleItems();
    updateButton();
  });
}
document.addEventListener("DOMContentLoaded", initBlogListViewMore);
document.addEventListener("shopify:section:load", initBlogListViewMore);


/* ==========================================================================
  Collection Product Recommendations
========================================================================== */
function initCollectionProductRecommendations(root = document) {
  const recommendationSections = root.querySelectorAll(
    ".collection-product-recommendations[data-url]"
  );
  if (!recommendationSections.length) return;
  recommendationSections.forEach((section) => {
    if (section.dataset.recommendationsInitialized === "true") return;
    section.dataset.recommendationsInitialized = "true";
    loadCollectionProductRecommendations(section);
  });
}
async function loadCollectionProductRecommendations(section) {
  const requestUrl = section.dataset.url;
  const sectionId = section.id;
  if (!requestUrl || !sectionId) return;
  section.classList.add("is-loading");
  try {
    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });
    if (!response.ok) {
      throw new Error(
        `Recommendations request failed: ${response.status}`
      );
    }
    const responseText = await response.text();
    const responseDocument = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );
    const loadedSection = responseDocument.getElementById(sectionId);
    if (!loadedSection) {
      throw new Error(
        `Recommendation section was not found: ${sectionId}`
      );
    }
    const currentBody = section.querySelector(
      ".collection-product-recommendations__body"
    );
    const loadedBody = loadedSection.querySelector(
      ".collection-product-recommendations__body"
    );
    const productList = loadedSection.querySelector(
      ".product-recommendations"
    );
    if (!currentBody || !loadedBody || !productList) {
      section.hidden = true;
      return;
    }
    currentBody.innerHTML = loadedBody.innerHTML;
    section.hidden = false;
    section.classList.add("is-loaded");
    initializeCollectionRecommendationAnimations(section);
  } catch (error) {
    console.error(
      "Collection product recommendations could not be loaded.",
      error
    );
    section.hidden = true;
  } finally {
    section.classList.remove("is-loading");
  }
}

function initializeCollectionRecommendationAnimations(section) {
  const animatedElements = section.querySelectorAll("[data-aos]");
  animatedElements.forEach((element) => {
    element.classList.add("aos-animate");
  });
  if (
    window.theme &&
    window.theme.initProductGridItem
  ) {
    section
      .querySelectorAll(".grid-product")
      .forEach((productItem) => {
        window.theme.initProductGridItem(productItem);
      });
  }
}
document.addEventListener("DOMContentLoaded", () => {
  initCollectionProductRecommendations();
});
document.addEventListener("shopify:section:load", (event) => {
  initCollectionProductRecommendations(event.target);
});


/* ==========================================================================
  Product card color thumbnails
========================================================================== */
function initProductCardColorThumbnails() {
  document.addEventListener("click", event => {
    const thumbnail = event.target.closest(".js-grid-product-color-thumbnail");

    if (!thumbnail) return;

    event.preventDefault();
    event.stopPropagation();

    changeProductCardImage(thumbnail);
  });

  document.addEventListener("keydown", event => {
    const thumbnail = event.target.closest(".js-grid-product-color-thumbnail");

    if (!thumbnail) return;
    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    event.stopPropagation();

    changeProductCardImage(thumbnail);
  });
}

function changeProductCardImage(thumbnail) {
  const variantImage = thumbnail.dataset.variantImage;
  const productCard = thumbnail.closest(".grid-product");

  if (!variantImage || !productCard) return;

  const mainImage = productCard.querySelector(".grid-product__main-image");

  if (!mainImage) return;

  // srcsetが残っていると元画像が優先される場合があるため削除
  mainImage.removeAttribute("srcset");
  mainImage.removeAttribute("sizes");
  mainImage.src = variantImage;

  // picture要素が使われている場合はsourceのsrcsetも削除
  const picture = mainImage.closest("picture");

  if (picture) {
    picture.querySelectorAll("source").forEach(source => {
      source.removeAttribute("srcset");
    });
  }

  const thumbnails = productCard.querySelectorAll(
    ".js-grid-product-color-thumbnail"
  );

  thumbnails.forEach(item => {
    const isSelected = item === thumbnail;

    item.classList.toggle("is-active", isSelected);
    item.setAttribute("aria-pressed", isSelected ? "true" : "false");
  });

  // カラー画像選択後は既存のホバー画像を表示しない
  productCard.classList.add("is-variant-image-selected");
}

initProductCardColorThumbnails();



/*============================================================================
  Product variant color image switch
==============================================================================*/
function normalizeProductColorName(value) {
  if (!value) return "";
  let normalized = value
    .normalize("NFKC")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/[×✕✖]/g, "x")
    .replace(/[／/・]/g, "x");
  const replacements = {
    ブラック: "black",
    黒: "black",
    ホワイト: "white",
    白: "white",
    レッド: "red",
    赤: "red",
    ブルー: "blue",
    青: "blue",
    ネイビー: "navy",
    グレー: "gray",
    グレイ: "gray",
    灰色: "gray",
    イエロー: "yellow",
    黄: "yellow",
    グリーン: "green",
    緑: "green",
    ピンク: "pink",
    オレンジ: "orange",
    パープル: "purple",
    紫: "purple",
    ベージュ: "beige",
    ブラウン: "brown",
    茶: "brown",
    カーキ: "khaki",
    オリーブ: "olive",
    アイボリー: "ivory",
    クリーム: "cream",
    シルバー: "silver",
    ゴールド: "gold",
    ワイン: "wine",
    バーガンディ: "burgundy",
    ターコイズ: "turquoise",
    サックス: "sax"
  };
  Object.entries(replacements).forEach(([from, to]) => {
    normalized = normalized.replaceAll(from, to);
  });
  return normalized;
}
function initProductColorImageSwitch() {
  document.addEventListener("change", (event) => {
    const input = event.target.closest(
      ".variant-wrapper--color input[data-variant-input]"
    );
    if (!input) return;
    const productSection =
      input.closest("[data-section-id]") ||
      input.closest(".product-section") ||
      document;
    const slideshow = productSection.querySelector(
      "[data-product-photos].product-slideshow"
    );
    if (!slideshow) return;
    const selectedColor = normalizeProductColorName(input.value);
    if (!selectedColor) return;
    const slides = Array.from(
      slideshow.querySelectorAll(".product-main-slide")
    );
    const targetIndex = slides.findIndex((slide) => {
      const image = slide.querySelector("img");
      if (!image) return false;
      const imageColor = normalizeProductColorName(image.alt);
      return imageColor === selectedColor;
    });
    if (targetIndex < 0) return;
    const flickity = Flickity.data(slideshow);
    if (!flickity) return;
    flickity.select(targetIndex, false, true);
  });
}
document.addEventListener("DOMContentLoaded", initProductColorImageSwitch);

/*============================================================================
  Move product color selector on mobile
==============================================================================*/
function initMobileProductColorPosition() {
  const productMetaList = document.querySelectorAll(".product-single__meta");
  productMetaList.forEach((productMeta) => {
    const productHeader = productMeta.querySelector(".product-block--header");
    const colorSelector = productMeta.querySelector(".variant-wrapper--color");
    if (!productHeader || !colorSelector) return;
    const placeholder = document.createComment(
      "product-color-original-position"
    );
    colorSelector.parentNode.insertBefore(
      placeholder,
      colorSelector
    );
    function updatePosition() {
      const isMobile = window.innerWidth <= 896;
      if (isMobile) {
        productMeta.insertBefore(
          colorSelector,
          productHeader
        );
      } else {
        placeholder.parentNode.insertBefore(
          colorSelector,
          placeholder.nextSibling
        );
      }
    }
    updatePosition();

    window.addEventListener(
      "resize",
      theme.utils.debounce(200, updatePosition)
    );
  });
}
document.addEventListener(
  "DOMContentLoaded",
  initMobileProductColorPosition
);


/* ==========================
hCaptcha notice translation
========================== */
function translateHCaptchaNotice() {
  const replaceNotice = () => {
    const elements = document.querySelectorAll("p, div");

    elements.forEach((element) => {
      const text = element.textContent.trim();

      if (
        text ===
        "This site is protected by hCaptcha and the hCaptcha Privacy Policy and Terms of Service apply."
      ) {
        element.innerHTML = `
          このサイトはhCaptchaによって保護されており、hCaptchaの
          <a href="https://www.hcaptcha.com/privacy" target="_blank" rel="noopener">プライバシーポリシー</a>
          および
          <a href="https://www.hcaptcha.com/terms" target="_blank" rel="noopener">利用規約</a>
          が適用されます。
        `;
      }
    });
  };

  replaceNotice();

  const observer = new MutationObserver(() => {
    replaceNotice();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", translateHCaptchaNotice);
document.addEventListener("shopify:section:load", translateHCaptchaNotice);